module.exports = __webpack_public_path__ + "img/14.5d2e7b49.png";